export default {"src":"/_next/static/media/white-virtual-tour-icon.13f6e21e.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};